<template>
  <div class="box">
    <p class="page_title">车辆信息库</p>
    <div class="content_box">
      <div class="">
        <el-form :model="form" ref="form" size="mini" label-width="90px">
          <el-row>
            <el-col :span="5">
              <el-form-item label="车主姓名">
                <el-input
                    v-model="form.carOwner"
                    size="medium"
                    placeholder="请输入车主姓名"
                    clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="车牌号">
                <el-input
                    v-model="form.carNo"
                    size="medium"
                    placeholder="请输入车牌号"
                    clearable
                ></el-input>
              </el-form-item>
            </el-col>
<!--            <el-col :span="5">-->
<!--              <el-form-item label="车辆类型">-->
<!--                <el-select-->
<!--                    v-model="form.carType"-->
<!--                    placeholder="请选择车辆类型"-->
<!--                    clearable-->
<!--                    style="width: 100%"-->
<!--                >-->
<!--                  <el-option label="校内车" value="1" />-->
<!--                  <el-option label="校外车" value="other" />-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="4">-->
<!--              <el-form-item label="车辆状态">-->
<!--                <el-select-->
<!--                    v-model="form.state"-->
<!--                    placeholder="请选择车辆状态"-->
<!--                    clearable-->
<!--                    style="width: 100%"-->
<!--                >-->
<!--                  <el-option label="正常" value="0" />-->
<!--                  <el-option label="异常" value="1" />-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="6" class="button-group">
              <el-button size="medium" type="primary" icon="el-icon-search" @click="qryInfo()">查询</el-button>
              <el-button size="medium" icon="el-icon-refresh" @click="qryInfo('no')">重置</el-button>
<!--              <el-button size="medium" type="success" icon="el-icon-plus" @click="addVisible = true">新增</el-button>-->
              <el-button size="medium" type="warning" icon="el-icon-download" @click="exportExcel">导出</el-button>
              <el-button size="medium" type="success" icon="el-icon-refresh" @click="openClearScoreDialog" :disabled="selectedCars.length === 0">清分</el-button>
<!--              <el-button size="medium" type="info" icon="el-icon-upload2" @click="importVisible = true">导入</el-button>-->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table_box">
        <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%"
            v-loading="loading"
            @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="carNo" label="车牌号" min-width="100" align="center"></el-table-column>
          <el-table-column prop="carOwner" label="车主姓名" min-width="100" align="center"></el-table-column>
          <el-table-column prop="carTypeCh" label="车辆类型" min-width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.carType === '1' ? '校内车' : '校外车' }}
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="联系方式" min-width="120" align="center"></el-table-column>
          <el-table-column prop="score" label="累计记分" min-width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.levelAndScore[0] }} 档 {{ scope.row.levelAndScore[1] }} 分({{ scope.row.score }})
            </template>
          </el-table-column>
<!--          <el-table-column prop="stateText" label="当前状态" min-width="100" align="center"></el-table-column>-->
          <el-table-column prop="note" label="备注" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column fixed="right" label="操作" width="200" align="center">
            <template slot-scope="scope">
<!--              <el-button-->
<!--                  @click="handleClick(scope.row)"-->
<!--                  type="primary"-->
<!--                  icon="el-icon-search"-->
<!--                  size="small"-->
<!--              >查看</el-button>-->
<!--              <el-button type="warning" size="small" @click="updateSum(scope.row)">清空违章</el-button>-->
              <el-button type="danger" icon="el-icon-delete" size="small" @click="del(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            style="text-align: right; margin-top: 20px;"
        />
      </div>
    </div>
    <the-add :visible.sync="addVisible" @closeDialog="closeDialogClose" @success="operationFinish"></the-add>
    <the-edit :visible.sync="viewVisible" :data="upForm" @find="qryInfo"></the-edit>

    <el-dialog :visible.sync="importVisible" title="导入车辆信息" top="1vh" width="500px">
      <el-upload
          class="upload-demo"
          drag
          :action="importUserExcelUrl"
          :headers="fileUploadHeaders"
          :on-success="onUserUploadSuccess"
          :before-upload="beforeUpload"
          multiple
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">
          只能上传xls/xlsx文件，且不超过500kb.
          <br>
          <br>
          <span style="color: #F56C6C">请确保导入车牌号不为空，否则会导入失败！</span>
          <br>
          <el-button type="text" @click="downloadUserImportExcelModule">点击这里</el-button>下载导入模板
        </div>

      </el-upload>
    </el-dialog>

    <!-- 清分对话框 -->
    <el-dialog
      :visible.sync="clearScoreDialogVisible"
      title="车辆清分"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="clearScoreForm" label-width="120px">
        <el-form-item label="已选车辆">
          <div style="max-height: 150px; overflow-y: auto; border: 1px solid #dcdfe6; padding: 10px; border-radius: 4px;">
            <div v-for="(car, index) in selectedCars" :key="index" style="margin-bottom: 5px;">
              {{ car.carNo }} - {{ car.carOwner }}
            </div>
          </div>
          <div style="color: #909399; font-size: 12px; margin-top: 5px;">
            共 {{ selectedCars.length }} 辆车，最多支持20辆
          </div>
        </el-form-item>
        <el-form-item label="清分方式" required>
          <el-radio-group v-model="clearScoreForm.type">
            <el-radio :label="0">清空记分并取消当前的处罚</el-radio>
            <el-radio :label="1">仅清分</el-radio>
            <el-radio :label="2">仅取消当前的处罚</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearScoreDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmClearScore" :loading="clearScoreLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import index from "@/components/mixins/index";
import TheAdd from "./TheAdd.vue";
import TheEdit from "./TheView.vue";
import {getUserType, findSmartCar, delSmartCar, findSmartCarWxb} from "./api/index"
import request from '@/utils/apiRequest'
import {findPeopleInputWxb} from "../../personManage/personApply/api";
export default {
  mixins: [index],
  data() {
    return {
      form: {},
      loading: false,
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      options: [],
      event_type: "",
      tableData: [],
      selectedCars: [], // 选中的车辆
      clearScoreDialogVisible: false, // 清分对话框显示状态
      clearScoreLoading: false, // 清分加载状态
      clearScoreForm: {
        type: 0 // 清分方式：0-清空记分并取消当前的处罚、1-仅清分、2-仅取消当前的处罚
      },
      addVisible: false,
      viewVisible: false,
      fileUploadHeaders: {
        "Authorization": 'bearer ' + sessionStorage.getItem("access_token")
      },
      importVisible: false,
      importUserExcelUrl: process.env.VUE_APP_BASE_API + '/user/smartCar/import',
      upForm: {},
      //网信办访客车
      current: 1,
      size: 10,
      total: 0,
      wxbForm: {
      },
      tableWxbData: [],
      tableWxbColumns: [
        { label: "车牌号", prop: "carNo" },
        { label: "访客姓名", prop: "visitorName" },
        { label: "访客电话", prop: "visitorTel" },
        { label: "身份证", prop: "idCard" },
        { label: "预定日期", prop: "reserveDay" },
        { label: "开始时间", prop: "startTime" },
        { label: "结束时间", prop: "endTime" },
        { label: "来访原因", prop: "content" },
        { label: "创建时间", prop: "createTime" },
      ],
    };
  },
  methods: {
    closeDialogClose() {
      this.addVisible = false
      this.qryInfo();
    },
    // 清空违章次数
    updateSum(row) {
      this.$confirm('此操作将清空违章次数，但不会移除黑名单，是否继续操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/user/smartCar/updateSumBreak?id=' + row.id,
          method: 'get',
          loading: true
        }).then(response => {
          this.qryInfo();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //网信办访客车
    wxbInfo(form) {
      if(form==='no'){
        this.wxbForm = {}
      }
      let data = Object.assign({}, this.wxbForm);
      data.current = this.current;
      data.size = this.size;
      findSmartCarWxb(data)
          .then((res) => {
            this.tableWxbData = res.data.data.wxbList;
            this.total = res.data.data.total;
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "查询失败", {
              type: "error",
            });
          });
    },
    // 修改每页显示数量
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.qryInfo();
    },
    // 翻页
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.qryInfo();
    },
    handleClick(row) {
      this.upForm = row;
      if(row.state==="正常"){
        this.upForm.state2 = "0";
      }else if(row.state==="异常"){
        this.upForm.state2 = "1";
      }else {
        this.upForm.state2 = null;
      }
      this.viewVisible = true;
    },
    // eventHandle(item) {
    //   let tempIndex = this.event_type_list.indexOf(item);
    //   this.event_type_list = this.event_type_list.map((item) => {
    //     item.active = false;
    //     return item;
    //   });
    //   this.event_type_list[tempIndex].active = true;
    // },
    operationFinish(){
      this.addVisible = false;
      this.qryInfo();
    },
    qryInfo(form){
      if(form === 'no'){
        this.form = {}
      }
      this.loading = true;
      let data = Object.assign({},this.form);
      data.current = this.page.pageNum;
      data.size = this.page.pageSize;
      if(this.form.time!=null){
        data.startTime = this.form.time[0];
        data.endTime = this.form.time[1];
      }
      // 处理车辆类型筛选
      if(data.carType === 'other') {
        delete data.carType;
        data.isMsCar = null; // 查询所有非校内车
      } else if(data.carType === '1') {
        data.isMsCar = false; // 校内车
      } else {
        delete data.carType;
        data.isMsCar = null; // 不筛选
      }
      findSmartCar(data)
        .then((res) => {
          this.tableData = res.data.data.records;
          this.page.total = res.data.data.total;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$alert("服务器发生错误，请联系系统管理员", "查询失败", {
            type: "error",
          })
        });
    },
    getUserType(){
      getUserType('1002')
        .then((res) =>{
          this.options = res.data.data;
        })
    },
    del(index,row){
      this.$confirm('此操作将永久删除该车辆信息,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delSmartCar(row.id)
            .then((res)=>{
              this.qryInfo();
            })
        }).catch(() => {
        });
    },
    // 导入回调
    onUserUploadSuccess(response) {
      if (response.code == '20000') {
        this.$message.success('操作成功')
        this.importVisible = false
        this.qryInfo()
      } else {
        this.$message.error(response.data)
      }
      this.$loading().close()
    },
    // 导入前
    beforeUpload() {
      this.$loading()
    },
    // 下载导入模板
    downloadUserImportExcelModule() {
      window.location.href = process.env.BASE_URL + '车辆导入模板.xls'
    },
    // 构建筛选内容
    buildQueryForm() {
      let data = Object.assign({},this.form);
      // data.current = this.page.pageNum;
      // data.size = this.page.pageSize;
      // if (data.time != null && data.time.length == 2) {
      //   data.startTime = data.time[0]
      //   data.endTime = data.time[1]
      // }
      // delete data.time
      delete data.total
      return data
    },
    // 导出
    exportExcel() {
      const queryForm = this.buildQueryForm()
      request({
        url: '/user/car/exportExcel',
        params: queryForm,
        method: 'get',
        responseType: 'blob',
        loading: true
      })
    },
    // 表格选择变化
    handleSelectionChange(selection) {
      this.selectedCars = selection;
    },
    // 打开清分对话框
    openClearScoreDialog() {
      if (this.selectedCars.length === 0) {
        this.$message.warning('请至少选择一辆车');
        return;
      }
      if (this.selectedCars.length > 20) {
        this.$message.warning('一次最多只能清分20辆车');
        return;
      }
      this.clearScoreForm.type = 0; // 重置为默认选项
      this.clearScoreDialogVisible = true;
    },
    // 确认清分
    confirmClearScore() {
      // 获取选中的车牌号，用逗号分隔
      const carCodes = this.selectedCars.map(car => car.carNo).join(',');
      
      this.clearScoreLoading = true;
      request({
        url: '/user/smartCar/clearScore',
        method: 'get',
        params: {
          carCodes: carCodes,
          type: this.clearScoreForm.type
        },
        loading: false
      }).then(response => {
        this.clearScoreLoading = false;
        this.clearScoreDialogVisible = false;
        this.$message.success('清分操作成功');
        // 清空选中状态
        this.selectedCars = [];
        // 刷新列表
        this.qryInfo();
      }).catch(err => {
        this.clearScoreLoading = false;
        this.$message.error('清分操作失败，请稍后重试');
      });
    },
  },
  components: {
    TheAdd,
    TheEdit
  },
  created() {

  },
  mounted(){
    //this.getUserType();
    this.qryInfo();
    // this.qryMsInfo();
    // this.qryFkInfo();
    // this.wxbInfo();
  }
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  min-height: calc(100vh - 60px);
  box-sizing: border-box;
  background: #f5f7fa;
  padding: 20px;
  
  .page_title {
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-left: 4px solid #409eff;
    font-size: 16px;
    font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
    color: #303133;
    font-weight: 600;
    padding: 0 20px;
    margin-bottom: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
  
  .content_box {
    width: 100%;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 20px;
    
    .query_box {
      background: #ffffff;
      padding: 20px;
      border-radius: 4px;
      margin-bottom: 20px;
      border: 1px solid #ebeef5;
    }
    
    .table_box {
      background: #ffffff;
      padding: 20px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      
    }
  }
}
</style>
